import { render, staticRenderFns } from "./DefaultMetrics.vue?vue&type=template&id=317164d8"
import script from "./DefaultMetrics.vue?vue&type=script&lang=ts"
export * from "./DefaultMetrics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports